import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InlinePrompt from "@Shared/components/general/inline-prompt";
import { filter } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ESignManageTemplatesPage",
  components: {
    InlinePrompt
  },
  props: {
    templates: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      collapsedSections: [],
      MAX_TEXT_LENGTH: 65
    };
  },
  computed: {
    completeTemplates() {
      return filter(this.templates, template => template.complete);
    },
    isValid() {
      return true;
    },
    table() {
      return {
        columns: ["name", "description", "message", "createdAt", "actions"],
        options: {
          skin: "table table-hover",
          filterable: false,
          sortable: [],
          perPage: 999999,
          headings: {
            name: this.$t("global.words.name"),
            description: this.$t("global.words.description"),
            message: this.$t("e-sign-package.emailMessage"),
            createdAt: this.$t("e-sign-package.createdAt"),
            actions: this.$t("global.words.actions")
          },
          showChildRowToggler: false,
          tabbable: false,
          columnsClasses: {
            name: "w-10",
            description: "w-30",
            message: "w-30",
            createdAt: "w-20",
            actions: "w-auto"
          },
          texts: {
            noResults: this.$t("e-sign-package.messages.noTemplatesYet")
          }
        }
      };
    }
  },
  watch: {
    isValid: {
      handler(value) {
        this.$emit("valid", value);
      },
      immediate: true
    }
  },
  methods: {
    handleDeleteTemplate(eSignTemplateId) {
      this.$emit("template-delete", eSignTemplateId);
    },
    handleEditTemplate(eSignTemplateId) {
      this.$emit("template-edit", eSignTemplateId);
    },
    showExpansibleButton(text) {
      return text && text.length > 65;
    },
    isCollapse(section) {
      var _context;
      return _includesInstanceProperty(_context = this.collapsedSections).call(_context, section);
    },
    collapseText(section) {
      var _context2;
      const position = _indexOfInstanceProperty(_context2 = this.collapsedSections).call(_context2, section);
      if (position >= 0) {
        var _context3;
        _spliceInstanceProperty(_context3 = this.collapsedSections).call(_context3, position, 1);
        return;
      }
      this.collapsedSections.push(section);
    },
    truncateText(text, section) {
      return this.isCollapse(section) ? text : this.$options.filters.truncateText(text, this.MAX_TEXT_LENGTH);
    }
  }
});